import { api } from '@shared/api';

/**
 * «Задание дня» на главной (решение владельца 2026-10-22): 5 новых слов из готовых модулей Lomora, которых у
 * ученика ещё нет, → знакомство → тренировка со случайными упражнениями → несгораемые жетоны.
 * available — ещё не брал; ready — слова выданы (лежат в модуле «Задания дня»); done — выполнено;
 * empty — новых слов в каталоге для ученика не осталось.
 */
export type DailyTaskStatus = 'available' | 'ready' | 'done' | 'empty';

export interface DailyTaskWord {
  /** user_card_state.id копии слова в модуле «Задания дня». */
  stateId: string;
  front: string;
  transcription: string | null;
  pos: string | null;
  translations: string[];
  exampleEn: string | null;
  exampleRu: string | null;
  definition: string | null;
}

export interface DailyTask {
  status: DailyTaskStatus;
  moduleId: string | null;
  stateIds: string[];
  words: DailyTaskWord[];
  /** Начислено за выполнение (у done). */
  reward: number;
  /** Сколько жетонов дадут за выполнение. */
  rewardTokens: number;
  wordsCount: number;
  /** ISO UTC: когда появится новое задание (00:00 МСК). */
  resetsAt: string;
}

// Ответ бэка — в snake_case, домен — в camelCase (как в planApi).
interface BackendDailyTask {
  status: DailyTaskStatus;
  module_id: string | null;
  state_ids: string[];
  words: {
    state_id: string;
    front: string;
    transcription: string | null;
    pos: string | null;
    translations: string[];
    example_en: string | null;
    example_ru: string | null;
    definition: string | null;
  }[];
  reward: number;
  reward_tokens: number;
  words_count: number;
  resets_at: string;
}

function mapTask(d: BackendDailyTask): DailyTask {
  return {
    status: d.status,
    moduleId: d.module_id,
    stateIds: d.state_ids,
    words: d.words.map((w) => ({
      stateId: w.state_id,
      front: w.front,
      transcription: w.transcription,
      pos: w.pos,
      translations: w.translations,
      exampleEn: w.example_en,
      exampleRu: w.example_ru,
      definition: w.definition,
    })),
    reward: d.reward,
    rewardTokens: d.reward_tokens,
    wordsCount: d.words_count,
    resetsAt: d.resets_at,
  };
}

export async function fetchDailyTask(): Promise<DailyTask> {
  const { data } = await api.get<BackendDailyTask>('/daily-task');
  return mapTask(data);
}

/** Выдать слова на сегодня; второе нажатие вернёт те же. */
export async function startDailyTask(): Promise<DailyTask> {
  const { data } = await api.post<BackendDailyTask>('/daily-task/start');
  return mapTask(data);
}
